import * as Yup from "yup";

export const initialValues = {

};

export const HOST_TYPE = {
  GMAIL: "GMAIL",
  HOTMAIL: "HOTMAIL",
  YAHOO: "YAHOO",
  CUSTOMIZED: "CUSTOMIZED"

};

const CompanySmtpSchema = Yup.object().shape({
  host: Yup.string().required("Required"),
  post: Yup.string().required("Required"),
  username: Yup.string().required("Required"),
  password: Yup.string().required("Required"),
});

export default CompanySmtpSchema;
